const Props = {
  isCard: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: '',
  },
  datetime: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  module: {
    type: String,
    default: '',
  },
  contentImages: {
    type: Array,
    default: () => {
      return [];
    },
  },
  images: {
    type: Array,
    default: () => {
      return [
        // {
        //   'urlHttps': 'https://img0.didiglobal.com/static/soda_public/do1_aNMJAqpATiUb7zLRhaXU',
        //   'url': 'http://img0.didiglobal.com/static/soda_public/do1_aNMJAqpATiUb7zLRhaXU',
        //   'key': 'do1_aNMJAqpATiUb7zLRhaXU'
        // }
      ];
    },
  },
  link: {
    type: String,
    default: '',
  },
  linkText: {
    type: String,
    default: '',
  },
  unRead: {
    type: Boolean,
    default: false,
  },
  msgType: {
    type: Number,
    default: 1,
  },
  close: {
    type: Function,
    default() {},
  },
};
export default Props;
